<style lang="scss" scoped>
  @import "./cart-items";
</style>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CartItems',

  props: {
    cartDetails: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(['products', 'subtotal', 'shipping', 'tax', 'totalPrice', 'currencyCode'])
  }
}
</script>

<template>
  <div class="cart-items">
    <div class="product-list mt-5">
      <div
        v-for="product in cartDetails.products"
        :key="product.productId"
        class="mb-2 product-section"
      >
        <div class="media mt-2">
          <router-link
            :id="'product-' + product.productId"
            :to="{name:'Product', params:{productId: product.productId,product:product}}"
          >
            <img
              :src="require(`@/assets/images/${product.image}`)"
              class="mr-3 img-thumbnail"
              width="100px"
            >
          </router-link>
          <div class="media-body">
            <h5 class="mt-0 mb-1">
              {{ product.name }}
            </h5>
            <p>{{ product.cartQuantity }}</p>
            <p>
              {{ (product.salePrice || product.price) }}
              <span
                v-html="currencyCode"
              />
            </p>
          </div>
        </div>
        <hr class="mt-4">
      </div>
    </div>
    <ul class="list-group">
      <li class="list-group-item">
        Subtotal
        <span
          id="cart-subtotal"
          class="float-right"
        >{{ cartDetails['subtotal'].toFixed(2) }}</span>
      </li>
      <li class="list-group-item">
        Shipping
        <span
          id="cart-shipping"
          class="float-right"
        >{{ cartDetails['shipping'].toFixed(2) }}</span>
      </li>
      <li class="list-group-item">
        Taxes
        <span
          id="cart-tax"
          class="float-right"
        >{{ cartDetails['tax'].toFixed(2) }}</span>
      </li>
      <li class="list-group-item list-group-item-primary">
        <h4 class="m-0">
          Total
          <span class="float-right">
            {{ cartDetails['totalPrice'].toFixed(2) }}
            <span
              id="cart-currency"
              data-test="cart-currency"
            >
              {{ currencyCode }}
            </span>
          </span>
        </h4>
      </li>
    </ul>
  </div>
</template>
